import { createContext } from "react";

const FirstStepsContext = createContext();

export default FirstStepsContext;